module.exports = __webpack_public_path__ + "img/menucn_6_2.e88392f2.svg";